import { useApiFormState } from '../../api/api-form/action'

export const useContactUsForm = () => {
  return useApiFormState(process.env.REACT_APP_API_CONTENT, `api/v1/contact-us`)
}
